<template lang="pug">
  .layout-full
    router-view
</template>

<script>

import AlertPop from '@/components/widgets/AlertPop';

export default {
  name: 'LayoutClean',
  components: {
    AlertPop,
  },
  data() {
    return {

    };
  },
  methods: {

  },
};
</script>

<style lang="scss" scoped>
.layout-full {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/LayoutFull.vue